import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

// components
import { Chip } from '@mui/material'
import CircleIcon from '@mui/icons-material/Circle'
// constants

// styles

// const renderBadge = ({circleIconColor, fontColor, backgroundColor, label }) => {
//   return (<Chip icon={<CircleIcon style={{fontSize: "small", color: circleIconColor}} />}
//   label={label} variant="outlined" style={{backgroundColor, color: fontColor }}/>)
// }

const SuccessBadge = () => (
  <Chip
    icon={<CircleIcon style={{ fontSize: 'small' }} />}
    label="Success"
    variant="outlined"
    style={{ backgroundColor: '#53CE76', color: '#FFF' }}
  />
)

const InProgressBadge = () => (
  <Chip
    icon={<CircleIcon style={{ fontSize: 'small', color: '#004685' }} />}
    label="InProgress"
    variant="outlined"
    style={{ backgroundColor: '#69D0FF', color: '#004685' }}
  />
)

const PartialProgressBadge = () => (
  <Chip
    icon={<CircleIcon style={{ fontSize: 'small', color: '#EB1700' }} />}
    label="InProgress"
    variant="outlined"
    style={{ color: '#EB1700' }}
  />
)

const FailedBadge = () => (
  <Chip
    icon={<CircleIcon style={{ fontSize: 'small', color: '#EB1700' }} />}
    label="Failed"
    variant="outlined"
    style={{ color: '#EB1700' }}
  />
)

const AlternativeBadge = ({ label, backgroundColor }) => {
  const { t } = useTranslation()
  return (
    <Chip
      label={t(label)}
      variant="outlined"
      style={{ backgroundColor, border: 'none', fontWeight: 500 }}
      sx={{ span: {
        fontFamily: "'JohnsonTextMedium' !important"
      }
      }}
    />
  )
}

function StatusBadge({ status, alternativeStyle = false }) {
  if (status === 'processed' || status === 'completed') {
    return alternativeStyle ? (
      <AlternativeBadge label="upload-completed" backgroundColor="#53CE7633" />
    ) : (
      <SuccessBadge />
    )
  }
  if (status === 'partial-processed') {
    return <PartialProgressBadge />
  }
  if (status === 'failed' || status === 'failed-validation') {
    return alternativeStyle ? (
      <AlternativeBadge label="upload-failed" backgroundColor="#FFD0CB" />
    ) : (
      <FailedBadge />
    )
  }
  return alternativeStyle ? (
    <AlternativeBadge label="upload-in-progress" backgroundColor="#69D0FF40" />
  ) : (
    <InProgressBadge />
  )
}

AlternativeBadge.propTypes = {
  label: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
}

StatusBadge.propTypes = {
  alternativeStyle: PropTypes.bool,
  status: PropTypes.string.isRequired,
}

StatusBadge.defaultProps = {
  alternativeStyle: false,
}

export default StatusBadge
